import { render, staticRenderFns } from "./XQ.vue?vue&type=template&id=e404f8de&scoped=true"
import script from "./XQ.vue?vue&type=script&lang=js"
export * from "./XQ.vue?vue&type=script&lang=js"
import style0 from "./XQ.vue?vue&type=style&index=0&id=e404f8de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e404f8de",
  null
  
)

export default component.exports